import React from "react";
import ProductList from "../../components/event/ProductList";

const ProductsPage = () => {
    return <ProductList/>
}

export default ProductsPage;